/**
 * Permissions in master-account context, granted only by `MasterAccountRole`.
 * A separate set from account `Permission` — neither ever appears in the other's role mapping.
 */
export const MasterAccountPermission = {
  // Create, detach and transfer clients
  CLIENTS_MANAGE: 'master.clients.manage',
  // Members, their master roles and invitations
  PEOPLE_MANAGE: 'master.people.manage',
  // Which accountants reach which clients
  ASSIGNMENTS_MANAGE: 'master.assignments.manage',
  // Plan, card and billing portal of the master's subscription
  BILLING_MANAGE: 'master.billing.manage',
  // Identity of the master account (name, IČO, DIČ, address)
  SETTINGS_MANAGE: 'master.settings.manage',
  // The master account's Bridges and their client installations
  INTEGRATIONS_MANAGE: 'master.integrations.manage',
  // Board, queue and cross-client search
  BOARD_READ: 'master.board.read',
  // Take over, hand over or release a document a colleague handles
  DOCUMENTS_REASSIGN: 'master.documents.reassign'
} as const;

export type MasterAccountPermission =
  (typeof MasterAccountPermission)[keyof typeof MasterAccountPermission];

/** Every master-account permission. */
export const ALL_MASTER_ACCOUNT_PERMISSIONS: readonly MasterAccountPermission[] =
  Object.values(MasterAccountPermission);
